import React, { useEffect, useState } from 'react';

import useTranslation from '../../../features/translation/hooks/useTranslation';
import { useAppSelector } from '../../../app/hooks';

import { getValueWithTwoDecimals } from '../../Solutions/utils';
import { FilterValuesObj } from '../../../features/filter/interfaces';
import { FilterValueKey } from '../../../features/filter/utils';
import './ResultsDisplay.scss';
import CriticalDisplay from './CriticalDisplay/CriticalDisplay';
import { LoadingIndicator } from '@festo-ui/react';

interface ResultsDisplayProps {
  results: FilterValuesObj;
  isQN: boolean;
}

enum TranslationsKeys {
  RESULT_FOR = 'resultFor',
  L_H = 'filterUnitLitrePerHour',
  L_MIN = 'filterUnitLitrePerMin',
  BAR = 'filterUnitBar',
  RESULT_P1 = 'filterCalculationResultP1',
  RESULT_P2 = 'filterCalculationResultP2',
  RESULT_QN = 'filterCalculationResultQn',
  ERROR = 'resultError',
}

const ResultsDisplay: React.FC<ResultsDisplayProps> = ({ results, isQN }) => {
  const t = useTranslation();
  const solutionsValue = useAppSelector((state) => state.results.solution);
  const isResultsLoading = useAppSelector((state) => state.results.isResultsLoading);

  let titleString = '';
  let resultValue: string | number = '';

  switch (results.calculationResult) {
    case 'P1':
      titleString = t(TranslationsKeys.RESULT_P1);
      resultValue = getValueWithTwoDecimals({ value: Number(results[FilterValueKey.SUPPLY_PRESSURE]) });
      break;
    case 'P2':
      titleString = t(TranslationsKeys.RESULT_P2);
      resultValue = getValueWithTwoDecimals({ value: Number(results[FilterValueKey.OUTPUT_PRESSURE]) });
      break;
    case 'QN':
      titleString = t(TranslationsKeys.RESULT_QN);
      resultValue = getValueWithTwoDecimals({ value: Number(results[FilterValueKey.DISCHARGE]) });
      break;
  }

  const Results =
    isResultsLoading === 'pending' || isResultsLoading === 'idle' ? (
      <div className={`overwrite-waiting-container pb-4 ${isQN && 'pt-10'}`}>
        <LoadingIndicator size="small" />
      </div>
    ) : isResultsLoading === 'error' ? (
      <div className="results-container is-actually-critical">
        <i className="fwe-icon fwe-icon-status-warning ocritical pt-0"></i>
        <p>{t(TranslationsKeys.ERROR)}</p>
      </div>
    ) : results.calculationResult === 'QN' ? (
      <>
        <div className="results-container">
          <span className="highlight-value">
            {resultValue}
            <span className="units">{t(TranslationsKeys.L_MIN)}</span>
          </span>
          <span className="highlight-value second-result">
            {solutionsValue?.flowratePerHour?.toFixed(0)}
            <span className="units">{t(TranslationsKeys.L_H)}</span>
          </span>
        </div>
        <div className="critical-container">
          <CriticalDisplay hasInfobutton />
        </div>
      </>
    ) : (
      <div className="highlight-value-2">
        {resultValue}
        <div className="units">{t(TranslationsKeys.BAR)}</div>
      </div>
    );

  return (
    <div className="results-display">
      <div className="results-display-title">
        {t(TranslationsKeys.RESULT_FOR)} {t(titleString)}
      </div>
      <div className="actual-results">{Results}</div>
    </div>
  );
};

export default ResultsDisplay;
